import DataTypesStore from './DataTypesStore'

class Stores {
    constructor(appContext){
        this.DataTypesStore = new DataTypesStore(appContext, this)
    }
}

export default Stores;
